import React from "react";
import styled from "styled-components";
import { Route, Switch, } from "react-router-dom";
import { connect } from "react-redux";
import { compose, withState, withHandlers, withContext, lifecycle, } from "recompose";
import PropTypes from "prop-types";
import R from "ramda";

import * as m from "../style/mixins";
import * as v from "../style/vars";

import {
	GridCell,
} from "../common";

import Panel from "./Panel";
import Pages from "./Pages";
import GalleryImages from "./Images/GalleryImages";
import Upload from "./Images/Upload";
import Topbar from "./Topbar";

// --------------------------------------------------

const EditorWrapper = styled.div`
`;

const ContentWrapper = styled.div`
	margin-left: ${v.dim.panel.width.other};
	${m.xs`margin-left: 0;`}
	z-index: 0;
	position: relative;
`;

const Fallback = () => <div><Topbar title = "Editor"/></div>;

const enhance = compose(
	connect(
		R.pick(['panelOpen']),
		{
			closePanel: () => ({ type: 'CLOSE_PANEL' }),
		}
	),
	lifecycle({
		componentDidUpdate(prevProps) {
			if (prevProps.location.pathname !== this.props.location.pathname) {
				this.props.closePanel();
			}
		},
	})
);

const Editor = ({ panelOpen, closePanel, }) => (
	<EditorWrapper open = { panelOpen }>
		<Panel/>
		<ContentWrapper onClick = { panelOpen ? closePanel : undefined }>
			<Switch>
				<Route path = "/editor/page/:page" component = { Pages }/>

				<Route path = "/editor/gallery/upload" component = { Upload }/>
				<Route path = "/editor/gallery/uploaded/:hash" component = { GalleryImages }/>
				<Route path = "/editor/gallery/tag/:tag" component = { GalleryImages }/>
				<Route path = "/editor/gallery" component = { GalleryImages }/>
				<Route component = { Fallback }/>
			</Switch>
		</ContentWrapper>
	</EditorWrapper>
);

export default enhance(Editor);


// WEBPACK FOOTER //
// ./src/components/Editor/index.js